module.exports = __webpack_public_path__ + "img/Good_Casper-logo.db796798.png";